/**
 * /flights/results is often stale after the wizard moves to self-compose
 * summary or flight details. Do not treat that URL as "go back to the list"
 * except on real browser Back (POP).
 */
export function shouldForceWizardBackToResults({
  urlStep,
  currentStep,
  navigationType,
}) {
  if (urlStep !== "results") return false;
  if (currentStep !== "flightDetails" && currentStep !== "selfComposePick") {
    return false;
  }
  return navigationType === "POP";
}
